import { useTravelTimeNamesLazyQuery } from '@kinetic-ui/data-layer';
import { DataSource, FormOption } from '@qfa/forms';
import { getNodes } from 'kineticUtils';
import { useCallback } from 'react';

export const useTravelTimeNamesDataSource = (): DataSource<FormOption[]> => {
  const [getTravelTimeNames] = useTravelTimeNamesLazyQuery({
    variables: {
      limit: 10000,
    },
  });

  const load = useCallback(async () => {
    const { data } = await getTravelTimeNames();
    const travelTimeOptions = getNodes(data?.travelTimes).map((travelTime) => ({
      label: travelTime.name,
      value: travelTime.id,
    }));

    return travelTimeOptions as FormOption[];
  }, [getTravelTimeNames]);

  return { load };
};
